import React, { Component } from "react";


import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from 'primereact/progressspinner';
import { Tooltip } from 'primereact/tooltip';
// import Navbar from "../Navbar";
import service from "../../utils/service";
import "primeflex/primeflex.css";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { InputTextarea } from "primereact/inputtextarea";
import { Paginator } from 'primereact/paginator';
import unionBy  from 'lodash.unionby';
import moment from "moment";
import "../../style/news.css";
import { Toast } from 'primereact/toast';

import { environment } from "../../env";
import groupBy from 'lodash.groupby';
import AccordionLoader from "../common/AccordionLoader";

let API = environment.API;
class NewsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayNewsForm: 0,
      channels: [],
      regions: [],
      countries: [],
      filterRegions: [],
      filterCountries: [],
      selectedChannel: [],
      selectedRegions: [],
      selectedCountries: [],
      selectedChannelsFilter: [],
      selectedRegionsFilter: [],
      selectedCountriesFilter: [],
      newsList: [],
      newsLoading: true,
      newsAddOrDelete: false,
      filteredNewsList: [],
      newsDescription: "",
      newsType: "Content",
      newsURL: "",
      newsContent: "",
      newsIndex: -1,
      region: "Europe",
      demoURL: "",
      deleteDialog: false,
      deleteItem: {},
      first: 0,
      rows: 10,
      thumbnailDialog: false,
      selectedThumbnail: -1,
      URLList: Array(15).fill(""),
      namesList: [
        {
          "display": "Coconut Oil",
          "actual" :  "News_Tropical_Oil.png",
        },
        {
          "display": "Rapeseed Oil",
          "actual" :  "News_Rapeseed_Canola.png",
        },
        {
          "display": "Soybean Oil",
          "actual" :  "News_Soybeans.png",
        },
        {
          "display": "Sunflower_Oil",
          "actual" :  "News_Sunflower.png",
        },
        {
          "display": "Economic",
          "actual" :  "News_Economic.png",
        },
        {
          "display": "Biofuels",
          "actual" :  "News_Biofuels.png",
        },
        {
          "display": "Palm Oil",
          "actual" :  "News_Cocoa.png",
        },
        {
          "display": "Corn",
          "actual" :  "News_Corn.png",
        },
        {
          "display": "Edible Oil",
          "actual" :  "News_Edible_Oil.png",
        },
        {
          "display": "Feed Meal",
          "actual" :  "News_Feed_Meal.png",
        },
        {
          "display": "Grain",
          "actual" :  "News_Grain.png",
        },
        {
          "display": "Sugar",
          "actual" :  "News_Sugar.png",
        },
        {
          "display": "Wheat",
          "actual" :  "News_Wheat.png",
        },
        {
          "display": "Cocoa",
          "actual" :  "Cocoa_news.png",
        },
        {
          "display": "General",
          "actual" :  "News_Thumbnail_Default.png",
        },
      ],
    };
    this.fileInput = React.createRef();
    this.toggleDisplay = this.toggleDisplay.bind(this);
    this.getCommodityNews = this.getCommodityNews.bind(this);
    this.deleteCommodityNews = this.deleteCommodityNews.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.saveCommodityNews = this.saveCommodityNews.bind(this);
    this.uploadAdBanner = this.uploadAdBanner.bind(this);
    this.setIndex = this.setIndex.bind(this);
    this.setDeleteDialog = this.setDeleteDialog.bind(this);
    this.setThumbnailDialog = this.setThumbnailDialog.bind(this);
    this.setSelectedThumbnail = this.setSelectedThumbnail.bind(this);
    this.setDeleteItem = this.setDeleteItem.bind(this);
    this.changeURLs = this.changeURLs.bind(this);
  }

  setDeleteDialog(val){
    this.setState({
      deleteDialog: val
    })
  }
  setThumbnailDialog(val){
    this.setState({
      thumbnailDialog: val
    })
  }
  setSelectedThumbnail(val){
    this.setState({
      selectedThumbnail: val
    })
  }
  
  setDeleteItem(newsItem){
    this.setState({
      deleteItem: newsItem
    })
  }

  resetState(){
    this.setState({
      newsDescription: "",
      newsType: "Content",
      newsURL: "",
      newsContent: "",
      selectedThumbnail: -1,
      selectedChannel: [],
      regions: [],
      countries: [],
      selectedRegions: [],
      selectedCountries: []
    });
  }

  changeURLs(val, ind){
    this.setState( prev => {
        var lis = prev.URLList
        if(ind < lis.length) lis[ind] = val
        return {
          URLList: lis
        }
    })
  }

  generateFileName(file, region) {
    let fileExtenstion = file.name.split(".").pop();
    let fileName =
      "AdBanner" +
      region +
      this.formatDateToImageUpload() +
      "." +
      fileExtenstion;
    return fileName;
  }

  setIndex(index) {
    this.setState((prevState) => {
      let ind = index;
      if (prevState.newsIndex === index) ind = -1;
      return {
        newsIndex: ind,
      };
    });
  }

  filterNews(){
    var curnews = this.state.newsList
    if (this.state.selectedChannelsFilter.length !== 0){
      const selchannelIds = this.state.selectedChannelsFilter.map(chnl => chnl.channelId)
      curnews = curnews.filter(news => {
        if (Array.isArray(news.channelId)) {
          return news.channelId.some(channelId => selchannelIds.includes(channelId))
        } else {
          return selchannelIds.includes(news.channelId)
        }        
      })
    }
    if (this.state.selectedRegionsFilter.length !== 0){
      const selRegionIds = this.state.selectedRegionsFilter.map(reg => reg.regionId)
        curnews = curnews.filter(news => news.regionalNewsResponseDTOS.map(reg => reg.regionId).filter(regId => selRegionIds.includes(regId)).length > 0)
    }
    if (this.state.selectedCountriesFilter.length !== 0){
      const selCountryIds = this.state.selectedCountriesFilter.map(ctry => ctry.countryId)
          curnews = curnews.filter(news => news.regionalNewsResponseDTOS.map(reg => reg.regionalCountryDTOS).flat().map(ctry => ctry.countryId).filter(ctryId => selCountryIds.includes(ctryId)).length > 0)
    }
    this.setState({filteredNewsList: curnews})
    // if (this.state.selectedChannelsFilter.length === 0){
    //   this.setState({filteredNewsList: curnews})
    // }
    // else {
    //   const selchannelIds = this.state.selectedChannelsFilter.map(chnl => chnl.channelId)
    //   curnews = curnews.filter(news => selchannelIds.includes(news.channelId))
    //   if (this.state.selectedRegionsFilter.length === 0){
    //     this.setState({filteredNewsList: curnews})
    //   }
    //   else {
    //     const selRegionIds = this.state.selectedRegionsFilter.map(reg => reg.regionId)
    //     curnews = curnews.filter(news => news.regionalNewsResponseDTOS.map(reg => reg.regionId).filter(regId => selRegionIds.includes(regId)).length > 0)
    //     if (this.state.selectedCountriesFilter.length === 0){
    //       this.setState({filteredNewsList: curnews})
    //     }
    //     else {
    //       const selCountryIds = this.state.selectedCountriesFilter.map(ctry => ctry.countryId)
    //       curnews = curnews.filter(news => news.regionalNewsResponseDTOS.map(reg => reg.regionalCountryDTOS).flat().map(ctry => ctry.countryId).filter(ctryId => selCountryIds.includes(ctryId)).length > 0)
    //       this.setState({filteredNewsList: curnews})
    //     }
    //   }
    // }
  }

  uploadAdBanner() {
    let file = this.fileInput;
    let region = this.state.region;
    let redirectUrl = this.state.advURL;
    let renamedFile = new window.File(
      [file],
      this.generateFileName(file, region),
      {
        type: "image/png",
        lastModified: Date.now(),
      }
    );
    service.postImageToS3(renamedFile).then((res, rej) => {});
    let imgUrl =
      "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/" +
      renamedFile.name;
    let data = {
      imageUrl: imgUrl,
      redirectUrl: redirectUrl,
      region: region,
    };
    service.sendAdDetails(region, data);
    this.setState({
      region: "Europe",
      advURL: "",
    });
  }

  toggleDisplay(val) {
    this.setState((prevState) => {
      return {
        [val]: !prevState[val],
      };
    });
  }

  getCommodityNews() {
    return service.getCommodityNews().then((response) => {
      const groupedNews = groupBy(response.data, r => `${r.title}-${r.content}`);
      const titleKeys = Object.keys(groupedNews);
      let combinedNews = [];
      for (let i = 0; i < titleKeys.length; i++) {
        let news = groupedNews[titleKeys[i]];
        if (news.length > 1) {
          let newsRec = {};
          let updatedChannelName = news.map(n => n.channelName).join(', ');
          let updatedChannelId = news.map(n => n.channelId);
          let updatedNewsId = news.map(n => n.newsId);
          let updatedRegionalNewsResponseDTOS = unionBy(...news.map(n =>n.regionalNewsResponseDTOS), 'regionId');
          let {channelName, regionalNewsResponseDTOS, channelId, newsId, ...rest} = news[0];
          newsRec = {
            ...rest,
            newsId: updatedNewsId,
            channelId: updatedChannelId,
            channelName: updatedChannelName,
            regionalNewsResponseDTOS: updatedRegionalNewsResponseDTOS
          }
          combinedNews.push(newsRec);
        } else {
          combinedNews.push(...news);
        }
      }
      this.setState({
        newsList: combinedNews,
        filteredNewsList: combinedNews
      });
    });
  }

  componentDidMount() {
    this.setState({
      newsLoading: true
    })
    this.getCommodityNews()
      .then(() => {
        this.setState({
          newsLoading: false
        });
      })
      .catch(err => {
        this.setState({
          newsLoading: false
        })
      });
    for(let i=0;i<this.state.namesList.length;i++){
      service.updateImageInList(this.state.namesList[i].actual, this.changeURLs, i)
    }
    service.getRegionCountry()
    .then(({data}) => {
      this.setState(state => {
        const { availableChannels} = data;
        const uninonRegions = unionBy(...availableChannels.map(channel => channel.regions), 'regionId')
        return ({
          filterCountries: uninonRegions.map(reg => reg.countries).flat(),
          channels: availableChannels,
          filterRegions: uninonRegions
        })
      })
    })
    // service.getChannels()
    // .then(({data: channels}) => this.setState(() => ({ channels })))
    // .catch(() => {})
    // service.getChannelRegions()
    // .then(({data: channelRegions}) => this.setState(() => ({ regions: channelRegions })))
    // .catch(() => {})
    
  }

  componentDidUpdate(prevProps, prevState) {
//     if (prevState.displayNewsForm !== this.state.displayNewsForm && this.state.displayNewsForm) {
//       let regions = this.state.channels.map(channel => channel.regions)  
//       const selectedRegions = unionBy(...regions, 'regionId');
//       this.setState(state => {
//       return ({
//         selectedCountries: this.state.countries,
//         selectedChannels: this.state.channels,
//         selectedRegions
//       })
//     })
//     }

  }
  handleChange(name, event) {
    this.setState({
      [name]: event.target.value,
    });
  }

  customFormatter(date) {
    return moment(date).format("YYYY-MM-DD");
  }

  getIndexes() {
    let arr = [], id = this.state.first
    for(var i=0;i<this.state.rows;i++){
      if(id >= this.state.filteredNewsList.length) break;
      arr.push(id);
      id++;
    }
    return arr;
  }

  saveCommodityNews() {
    const isContentSelected = this.state.newsType === "Content";
    const isUrlSelected = this.state.newsType === "URL Link";
    const invalidSelections = (this.state.selectedChannel.length === 0 || 
      this.state.selectedRegions.length === 0 || this.state.selectedThumbnail === -1 || this.state.newsDescription.trim() === "")

    const invalidNewsSelection = invalidSelections || this.state.newsContent.trim() === "";
    const invalidNewsUrlSelection = invalidSelections || this.state.newsURL.trim() === "";
    let isSelectionsInvalid = false;
    if (isContentSelected) isSelectionsInvalid = invalidNewsSelection;
    if (isUrlSelected) isSelectionsInvalid = invalidNewsUrlSelection;
    if (this.state.selectedRegions.length === 1 && this.state.selectedRegions[0].regionId === 6 && this.state.selectedCountries.length === 0) {  // TODO: remove once the countries for SA is added
      isSelectionsInvalid = false;
    } else if (this.state.selectedCountries.length === 0) {
      isSelectionsInvalid = true;
    }
    if(isSelectionsInvalid){

      this.toast.show({severity: 'warn', summary: 'Please fill all the required fields'})
      return
    }
    this.toggleDisplay("displayNewsForm");
    if (this.state.newsType !== "File") {
      let newsDataToPost = [];
      for (const channel of this.state.selectedChannel) {
        let newsData = {};
        newsData.createdDate = this.customFormatter(
          new Date().toISOString().slice(0, 10)
        );
        var newsType = {};
        newsType.name = this.state.newsType;
        if (isUrlSelected) {
          newsType.id = 1;
        }
        if (isContentSelected) {
          newsType.id = 2;
        }
        if (this.state.newsType === "File") {
          newsType.id = 3;
        }
        newsData.typeId = newsType.id;
        newsData.description = this.state.newsDescription;
        // newsData.createdBy = "admin";
        newsData.content = this.state.newsContent;
        newsData.link = this.state.newsURL;
        if(this.state.selectedThumbnail!==-1){
          newsData.imagePath = `${API}/downloadImage/${this.state.namesList[this.state.selectedThumbnail].actual}`
        }
        else{
          newsData.imagePath = `${API}/downloadImage/${this.state.namesList[this.state.namesList.length - 1].actual}`
        }
        newsData.channelId = channel.channelId;
        const channelRegionsIds = channel.regions.map(reg => reg.regionId);
        const selRegionsIds = this.state.selectedRegions.map(selReg => selReg.regionId);
        const selChannelRegIds = selRegionsIds.filter(id => channelRegionsIds.includes(id))

        var selRegCountries = [];
        var regionCountries = [];
        let selChannelRegCountryIds = [];
        for (const reg of channel.regions) {
            regionCountries = regionCountries.concat(reg.countries);
            const countryIds = reg.countries.map(ctry => ctry.countryId)
            const selcountryIds = this.state.selectedCountries.map(ctry => ctry.countryId)
            const selRegCountryIds = selcountryIds.filter(id => countryIds.includes(id))
            selChannelRegCountryIds = selChannelRegCountryIds.concat(selRegCountryIds)
            if (selRegCountryIds.length === reg.countries.length && selChannelRegIds.includes(reg.regionId)){
              selRegCountries.push({regionId: reg.regionId, country: "ALL"})
            }
            else {
              if(selRegCountryIds.length !== 0) {
                selRegCountries.push({regionId: reg.regionId, country: selRegCountryIds.join(',')})
              }              
            }
        }
        newsData.isAllRegions = channelRegionsIds.length === selChannelRegIds.length && regionCountries.length === selChannelRegCountryIds.length;
        newsData.regionalNewsRequestDTOS = newsData.isAllRegions ? [] : selRegCountries;
        newsDataToPost.push(newsData);
      }
      this.setState({
        newsAddOrDelete: true
      })
      service
        .saveCommodityNews(newsDataToPost)
        .then((response) => {
          this.getCommodityNews()
            .then(() => {
              this.setState({
                newsAddOrDelete: false
              })
            })
            .catch(err => {
              this.setState({
                newsAddOrDelete: false
              })
            });
            this.toast.show({severity:'success', summary: 'Success', detail:'News published successfully', life: 3000});
        })
        .catch((error) => {
          console.error(error);
          this.toast.show({severity:'error', summary: 'Error', detail:'Error while publishing news', life: 3000});
          this.setState({
            newsAddOrDelete: false
          })
        });
    } else {
      this.uploadFile();
    }
    this.resetState();
  }

  uploadFile() {
    service
      .uploadFile(
        this.fileInput,
        this.state.newsDescription,
        this.customFormatter(new Date().toISOString().slice(0, 10))
      )
      .then((response) => {
        this.toast.show({severity:'success', summary: 'Success', detail:'File uploaded successfully', life: 3000});
        this.getCommodityNews();
      })
      .catch((error) => {
        this.toast.show({severity:'error', summary: 'Error', detail:'Error while uploading file', life: 3000});
        console.error(error);
      });
  }
  
  deleteCommodityNews(id) {
    this.setState({
      newsAddOrDelete: true
    })
    const DeletePromise = (Array.isArray(id) ?
      Promise.all(id.map(i => service.deleteCommodityNews(i))):
      service.deleteCommodityNews(id)
    )
    DeletePromise.then(values => {
      this.toast.show({severity:'success', summary: 'Success', detail:'Selected news is deleted', life: 3000});
      this.getCommodityNews()
        .then(() => {
          this.setState({
            newsAddOrDelete: false
          })
        })
        .catch(err => {
          this.setState({
            newsAddOrDelete: false
          })
        });
    })
    .catch((error) => {
      this.toast.show({severity:'error', summary: 'Error', detail:'Error while deleting news', life: 3000});
      this.setState({
        newsAddOrDelete: false
      })
      console.error(error);
    });   
  }

  render() {
    const newsTypes = [
      { label: "URL Link", value: "URL Link" },
      { label: "Content", value: "Content" },
      // { label: "File", value: "File" },
    ];

    // const regions = [
    //   { label: "North America", value: "North America" },
    //   { label: "Europe", value: "Europe" },
    //   { label: "Latin America", value: "Latin America" },
    // ];

    let disabledCountries = false;
    if (this.state.selectedRegions.length === 1 && this.state.selectedRegions[0].regionId === 6) { // TODO: remove once the countries for SA is added
      disabledCountries = false;
    } else if (this.state.countries.length === 0) {
      disabledCountries = true;
    }
    return (
      <div className="main-box">
        <Toast ref={(el) => this.toast = el} baseZIndex={20000} />
        
          
        { this.state.displayNewsForm ?
                <Button
                  label="Add News"
                  className="btn3 news-btn"
                  disabled
                />
                :
                <div className="flex flex-row grid p-fluid">
                  <div className="field col-3 md:col-3">
                    <label htmlFor="selectedChannelsFilter">Channel</label>
                    <MultiSelect
                      optionLabel="channelName"
                      placeholder="Select Channels"
                      value={this.state.selectedChannelsFilter}
                      options={this.state.channels}
                      onChange={(e) => {
                        this.setState({selectedChannelsFilter: e.target.value},
                          () => this.filterNews())
                        // const newsFilterRegions = unionBy(...e.target.value.map(channel => channel.regions), 'regionId')
                        // this.setState({filterRegions: newsFilterRegions})
                        // this.filterNews()
                      }}       
                      id="selectedChannelsFilter"                        
                      // required 
                    />
                  </div>
                  <div className="field col-3 md:col-3">
                    <label htmlFor="selectedRegionsFilter">Region</label>
                    <MultiSelect
                      value={this.state.selectedRegionsFilter}
                      placeholder="Select Regions"
                      options={this.state.filterRegions}
                      id="selectedRegionsFilter"
                      optionLabel="region"
                      onChange={(e) => {
                        this.setState({selectedRegionsFilter: e.target.value},
                          () => this.filterNews())
                        // const selcountries = e.target.value.map(reg => reg.countries).flat()
                        // this.setState({filterCountries: selcountries})
                      }}                        
                      // required 
                    />
                  </div>
                  <div className="field col-3 md:col-3">
                    <label htmlFor="selectedCountriesFilter">Countries</label>
                    <MultiSelect
                      optionLabel="countryName"
                      placeholder="Select Countries"
                      value={this.state.selectedCountriesFilter}
                      options={this.state.filterCountries}
                      id="selectedCountriesFilter"
                      filter
                      // tooltip = {this.state.selectedChannel ? null : "Please select channel"}
                      // tooltipOptions = {{position : "bottom"}}
                      onChange={(e) => {
                        this.setState({selectedCountriesFilter: e.target.value},
                          () => this.filterNews())
                      }}                        
                      // required 
                    />
                  </div>
                  <div className="col-3 md:col-3">
                    <Button
                      onClick={() => this.toggleDisplay("displayNewsForm")}
                      label="Add News"
                      className="btn3 news-btn"
                    />
                  </div>
                </div>
              }
              {this.state.displayNewsForm ? (
                <div className="form-box clear">
                  <form
                    id="news-form"
                    onSubmit={(event) => {
                      event.preventDefault()
                      this.saveCommodityNews()
                    }
                    }
                  >
                    <p className="head-form">Add News Article</p>

                    <div className="p-fluid formgrid grid">
                      <div className="field col-12 md:col-6">
                        <label htmlFor="newsDescription">
                          News Description *
                        </label>
                        <InputText
                          id="newsDescription"
                          value={this.state.newsDescription}
                          type="text"
                          onChange={(event) => {
                            this.handleChange("newsDescription", event);
                          }}
                          required
                        />
                      </div>

                      <div className="field col-12 md:col-3">
                        <label htmlFor="newsType">Select Type *</label>
                        <Dropdown
                          className="p-dropdown"
                          id="newsType"
                          value={this.state.newsType}
                          options={newsTypes}
                          onChange={(event) => {
                            this.handleChange("newsType", event);
                          }}
                          // required
                        />
                      </div>

                      <div className="field col-12 md:col-3">
                        <Button
                          type="button"
                          onClick={() => this.setThumbnailDialog(true)}
                          label="Choose Thumbnail *"
                          className="btn2 mt-4"
                        />
                      </div>

                      <div className="field col-12 md:col-3">
                        <label htmlFor="selectedChannels">Channel *</label>
                        {/* <Dropdown
                          optionLabel="channelName"
                          value={this.state.selectedChannel}
                          options={this.state.channels}
                          onChange={(e) => {
                            this.setState((prevState) => ({...prevState, regions: e.target.value.regions}))
                            this.handleChange("selectedChannel", e);
                          }}       
                          id="selectedChannels"                        
                          // required 
                        /> */}
                        <MultiSelect
                          value={this.state.selectedChannel}
                          options={this.state.channels}
                          id="selectedChannels" 
                          optionLabel="channelName"
                          onChange={(e) => {
                            const selectedRegions = unionBy(...e.target.value.map(channel => channel.regions), 'regionId')

                            const selectedChannelRegionsIds = selectedRegions.map(selReg => selReg.regionId);
                            const setSelectedRegions = this.state.selectedRegions.filter(selReg => selectedChannelRegionsIds.includes(selReg.regionId));
                            const selcountries = setSelectedRegions.map(reg => reg.countries).flat();
                            const selectedCountriedIds = selcountries.map(selC => selC.countryId);
                            const setSelectedCountries = this.state.selectedCountries.filter(selCountry => selectedCountriedIds.includes(selCountry.countryId))
                            this.setState((prevState) => ({...prevState, regions: selectedRegions, selectedRegions:setSelectedRegions, countries: selcountries,selectedCountries: setSelectedCountries}))

                            this.handleChange("selectedChannel", e);
                          }}                        
                          // required 
                        />
                      </div>

                      <div className="field col-12 md:col-3">
                        <label htmlFor="selectedRegions">Region *</label>
                        <MultiSelect
                          disabled={this.state.regions.length === 0}
                          value={this.state.selectedRegions}
                          options={this.state.regions}
                          id="selectedRegions"
                          optionLabel="region"
                          onChange={(e) => {
                            const selcountries = e.target.value.map(reg => reg.countries).flat();
                            const selectedCountriedIds = selcountries.map(selC => selC.countryId);
                            const setSelectedCountries = this.state.selectedCountries.filter(selCountry => selectedCountriedIds.includes(selCountry.countryId))
                            this.setState((prevState) => ({...prevState, countries: selcountries, selectedCountries: setSelectedCountries}))
                            this.handleChange("selectedRegions", e);
                          }}                        
                          // required 
                        />
                      </div>

                      <div className="field col-12 md:col-3">
                        <label htmlFor="selectedCountries">Countries *</label>
                        <MultiSelect  
                          disabled={disabledCountries}
                          optionLabel="countryName"
                          value={this.state.selectedCountries}
                          options={this.state.countries}
                          id="selectedCountries"
                          filter
                          // tooltip = {this.state.selectedChannel ? null : "Please select channel"}
                          // tooltipOptions = {{position : "bottom"}}
                          onChange={(e) => {
                            this.handleChange("selectedCountries", e);
                          }}                        
                          // required 
                        />
                      </div>

                      {this.state.newsType === "URL Link" && (
                        <div className="field col-12 md:col-8">
                          <label htmlFor="newsURL">Link URL *</label>
                          <InputText
                            id="newsURL"
                            value={this.state.newsURL}
                            type="text"
                            onChange={(event) => {
                              this.handleChange("newsURL", event);
                            }}
                            required
                          />
                        </div>
                      )}

                      {this.state.newsType === "Content" && (
                        <div className="field col-12 md:col-8">
                          <label htmlFor="newsContent">News Content *</label>
                          <InputTextarea
                            id="newsContent"
                            rows={10}
                            value={this.state.newsContent}
                            onChange={(event) => {
                              this.handleChange("newsContent", event);
                            }}
                            required
                          />
                        </div>
                      )}

                      {this.state.newsType === "File" && (
                        <div className="field col-12 md:col-8">
                          <label>
                            News file
                            <br />
                            <input type="file" ref={this.fileInput} />
                          </label>
                        </div>
                      )}

                      <div className="field col-12 md:col-1 mt-3">
                        {this.state.selectedThumbnail !== -1 &&
                          <div>
                            <img src={this.state.URLList[this.state.selectedThumbnail]} alt={this.state.namesList[this.state.selectedThumbnail].display} style={{width: "60%"}}></img>
                            <p>{this.state.namesList[this.state.selectedThumbnail].display}</p>
                          </div>
                        }
                      </div>

                      <div className="field col-12 md:col-3 par-btn">
                        <Button
                          type="submit"
                          label="Publish"
                          className="btn3 btn-publish"
                          form="news-form"
                        />

                        <Button
                          type="button"
                          onClick={() => {
                            this.toggleDisplay("displayNewsForm")
                            this.resetState();
                          }}
                          label="Discard"
                          className="btn3 btn-discard"
                        />
                        <div className="clear"></div>
                      </div>
                    </div>
                  </form>
                </div>
              ): <></>}
              <div className = "clear" style={{ marginTop: "30px", position: "relative" }}>
                {this.state.newsAddOrDelete && <div style={{
                  position: 'absolute',
                  left: 0,
                  right: 0,
                  top: 0,
                  bottom: 0,
                  backgroundColor: "#000",
                  opacity: "0.65",
                  zIndex: 1,
                  display: "flex",
                  alignItems: "center"
                }}>
                  <ProgressSpinner />
                  {/* <div style={{color: "#FFF", margin: "0 auto"}}>Please wait...</div> */}
                </div>}                
                {this.state.newsLoading && <AccordionLoader />}
                {!this.state.newsLoading && this.getIndexes().map((index) => {
                  let item = this.state.filteredNewsList[index];
                  const isMultiChannel = item.channelName.indexOf(',') !== -1;
                  const regions = item.regionalNewsResponseDTOS.map(reg => reg.region).join(", ");
                  const countries = item.regionalNewsResponseDTOS.map(reg => reg.regionalCountryDTOS.map(ctry => ctry.country)).flat().join(", ");
                  const isMultiRegions = regions.indexOf(',') !== -1;
                  const isMultiCountries = countries.indexOf(',') !== -1;
                  return (
                    <div className="grid" key={index}>
                      <div className="col-fixed" style={{ width: "80px" }}>
                        <div className="box1 text-center">{index + 1}</div>
                      </div>
                      <div className="col">
                        <div className="box" >
                          {isMultiChannel && <Tooltip target="#newsTitle" mouseTrack mouseTrackLeft={10}/>}
                          <span id="newsTitle" data-pr-tooltip={isMultiChannel ? item.channelName : ''}>
                            {item.content !== null && item.title}{isMultiChannel ? '*' : ''}
                            {item.urlLink !== null && (
                              <a href={item.link} target="_blank" rel="noopener noreferrer" style={{ color: "#cccccc" }}>
                                {item.description}
                              </a>
                            )}
                          </span>
                          <span
                            onClick={() => this.setIndex(index)}
                            className="floatRight"
                          >
                            {this.state.newsIndex===index ? <i className="pi pi-chevron-up"></i> : <i className="pi pi-chevron-down"></i>}
                          </span>

                          <span
                            className="expand"
                            onClick={() => {
                              this.setDeleteItem(item)
                              this.setDeleteDialog(true)
                            }}
                          >
                            Delete
                          </span>


                          {this.state.newsIndex === index && (
                            <div className="seperatorContent">
                              <div className="grid p-fluid">
                                <div className="col-6">
                                  <label>{isMultiChannel ? "Channels" : "Channel"}</label>
                                  <div>{item.channelName}</div>
                                </div>

                                <div className="col-6">
                                  <label>{isMultiRegions ? "Regions" : "Region"}</label>
                                  <div>{regions}</div>
                                </div>

                                <div className="col-6">
                                  <label>{isMultiCountries ? "Countries" : "Country"}</label>
                                  <div>{countries}</div>
                                </div>

                                {
                                  item.urlLink === "" ? 
                                    <div className="col-12">
                                      <label>Content</label>
                                      <div>{item.content}</div>
                                    </div>
                                  :
                                  <div className="col-12">
                                    <a href={item.urlLink} target="_blank" rel="noopener noreferrer" style={{ color: "#cccccc" }}>Content Url</a>
                                  </div>
                                }
                                
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                )})}
                {!this.state.newsLoading && this.getIndexes().length > 0 &&
                <>
                  <div><i>* Multiple Channels. Hover title to see the channel names</i></div>
                  <Paginator first={this.state.first} rows={this.state.rows} totalRecords={this.state.filteredNewsList.length} rowsPerPageOptions={[10, 20, 50]} onPageChange={(e) => this.setState({first: e.first, rows: e.rows})}></Paginator>
                </>
                }
                {!this.state.newsLoading && this.getIndexes().length === 0 &&
                  <div className="drag-description">No data to show</div>
                }
              </div>
        <Dialog
          baseZIndex={10001}
          header="Delete Confirmation"
          visible={this.state.deleteDialog}
          style={{ width: "50vw" }}
          onHide={() => this.setDeleteDialog(false)}
          focusOnShow={false}
        >
          <p className="m-0">Are you sure you want to delete "<b>{this.state.deleteItem.title}</b>" ?</p>
          <div className="spacing1">
            <Button
              label="Close"
              onClick={() => this.setDeleteDialog(false)}
              className="p-button p-button-sm btn3"
            />
            <Button
              label="Confirm"
              onClick={() => {
                this.deleteCommodityNews(this.state.deleteItem.newsId)
                this.setDeleteDialog(false)
              }}
              autoFocus
              className="p-button p-button-sm btn3"
            />
          </div>
        </Dialog>
        <Dialog
          className="diag1"
          baseZIndex={10000}
          visible={this.state.thumbnailDialog}
          style={{ width: "50vw", minHeight: "60vh" }}
          focusOnShow={false}
          onHide={() => this.setThumbnailDialog(false)}
          header={<div className="col-12 p-0 diag-syndication">Choose Thumbnail</div>}
          footer={<div className="grid align-items-center">
              <div className="col-6">
              <div className="grid align-items-center">
                <div className="col-6 p-0 diag-syndication">Selected Thumbnail</div>
                  { this.state.selectedThumbnail!==-1
                    ?
                    <div className="col-6 text-center">
                      <img src={this.state.URLList[this.state.selectedThumbnail]} alt={this.state.namesList[this.state.selectedThumbnail].display} style={{width: "50%"}}></img>
                      <p className="m-0 p-0">{this.state.namesList[this.state.selectedThumbnail].display}</p>
                    </div>                      
                    :
                    <p>Click on a thumbnail to select it</p>
                  }
                </div>
              </div>
              <div className="col-6">
                <Button
                  label="Cancel"
                  className="p-button floatRight p-button-sm diag-discard-button"
                  onClick={() => {
                    this.setSelectedThumbnail(-1)
                    this.setThumbnailDialog(false)
                  }}
                />
                <Button
                  label="Save"
                  className="p-button floatRight p-button-sm diag-save-button"
                  onClick={() => this.setThumbnailDialog(false)}
                />
              </div>
          </div>}
        >
          <div className="diag-box">
            <div className="grid">
              {
                this.state.namesList.map((name, index, accArray) => {
                  const lastEleStyle = index === accArray.length - 1 ? { marginTop: '10px' } : {}
                  return (
                    <div className="col-3 text-center" key={name.display}>
                      <img src={this.state.URLList[index]} alt={name.display} 
                        style={{cursor: "pointer", width: "50%", ...lastEleStyle}} 
                        onClick={() => {this.setSelectedThumbnail(index)}}></img>
                      <p style={index === accArray.length - 1 ? lastEleStyle : {margin: "0px"}}>{name.display}</p>
                    </div>
                  )}
                )
              }
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}


export default NewsPage